<template>
  <h-list-page class="incomingInspectionTaskToolTip complaint-container">
    <div class="title-content">
      <div class="title">{{ h_i18n('c22f83d06e99f847043c118c9559fffd') }}</div>
      <div style="display: flex;flex-direction: row;">
        <div class="reset-btn" @click="handleBack">{{ h_i18n('625fb26b4b3340f7872b411f401e754c') }}</div>
        <div class="primary-btn" @click="handleSubmit" v-show="!$route.query.isDetail">{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</div>
      </div>
    </div>
    <div class="item-module">
      <div class="title">{{ h_i18n('8c1993121379da1f4aa496e62cc19049') }}</div>
      <div class="info-content">
        <div class="info-item">
          <div class="info-label">{{ h_i18n('bb549a34eacdc7e40a6411422ce82973') }}</div>
          <div class="info-content">{{ h_i18n('3dca46482e8752bb1ef932640a0d65a4') }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{ h_i18n('234138d3dc0714a3467a430bf2ac92f1') }}</div>
          <div class="info-content">{{ topDetailObj.oid || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{ h_i18n('3c5625a0344f3ed7b29ae7967d55aca1') }}</div>
          <div class="info-content">{{ topDetailObj.reportAt }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{ h_i18n('6500565a54f402029dc65535fc87e1dc') }}</div>
          <div class="info-content">{{ topDetailObj.pl || '--' }}</div>
        </div>
      </div>
      <div class="info-content">
        <div class="info-item">
          <div class="info-label">{{ h_i18n('ed6966a7afa83ed0ac72d5a42f95ec96') }}</div>
          <div class="info-content">{{ topDetailObj.business || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{ h_i18n('601f68f5515c15a2b444122a51a983f1') }}</div>
          <div class="info-content">{{ topDetailObj.productId || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{ h_i18n('7a43ed283269ac2f350275a222d81faf') }}</div>
          <div class="info-content">{{ topDetailObj.assembledAt || '--' }}</div>
        </div>
      </div>
    </div>
    <div class="item-module">
      <div class="title">{{ h_i18n('e92301c9df32a060914d9b4dc1c43284') }}</div>
      <div class="info-item1">
        <div class="info-label">{{ h_i18n('d81ffcad3d9585a8349075e3d6ee87c0') }}</div>
        <div class="info-content1">{{ topDetailObj.complain || '--'}}</div>
      </div>
      <div class="info-item1">
        <div class="info-label">{{ h_i18n('8cab09760948ba5cf48bff05c1ac1821') }}</div>
        <div class="info-content1">{{ topDetailObj.describer || '--' }}</div>
      </div>
      <div class="info-item1">
        <div class="info-label">{{ h_i18n('23868409356185a7c507feee52d99d00') }}</div>
        <div class="info-content1">{{ topDetailObj.cause || '--'}}</div>
      </div>
      <div class="info-content">
        <div class="info-item">
          <div class="info-label" style="width: 100px;">{{ h_i18n('2c163fc6e9f68853992e6f5541225320') }}</div>
          <div class="info-content" style="width:70%">{{ topDetailObj.moduleNum || '--'}}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{ h_i18n('755e939d6806c1a20c84ad28c5fc1354') }}</div>
          <div class="info-content">{{ topDetailObj.moduleName || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{ h_i18n('7df2998956788726f20cc7e0fdbab4e2') }}</div>
          <div class="info-content">{{ topDetailObj.port || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{ h_i18n('afb58de2a17924d231e8ca79db02edac') }}</div>
          <div class="info-content">{{ topDetailObj.branch || '--'}}</div>
        </div>
      </div>
      <div class="info-content">
        <div class="info-item">
          <div class="info-label">{{ h_i18n('f7044a4c38fd50e967a9a21176a447fa') }}</div>
          <div class="info-content">{{ topDetailObj.areaNO!='null'&&topDetailObj.areaNO!=null&&topDetailObj.areaNO!=''&&topDetailObj.areaNO!=undefined ? topDetailObj.areaNO : '--'}}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{ h_i18n('7d33dc005cbb20973ca97324aacea453') }}</div>
          <div class="info-content">{{ topDetailObj.branchPhone!=null&&topDetailObj.branchPhone!=''&&topDetailObj.branchPhone!=undefined ? topDetailObj.branchPhone : '--' }}</div>
        </div>
      </div>
      <div class="info-content">
        <div class="info-item" style="width: 100%;">
          <div class="info-label" style="width: 60px;">{{ h_i18n('a7ed0a8addd39bf67667705cd8232c9d') }}</div>
          <div class="info-content" style="width: 100%;">
            <!-- <img v-for="(item,index) in topDetailObj.pictureUrlList" :key="index" :src="item" class="info-img"> -->
            <el-image class="info-img" v-for="item in topDetailObj.pictureUrlList" :key="item" :src="$filePathSplicing(item, 'img')" :zoom-rate="1" :max-scale="7" :min-scale="0.2" :preview-src-list="topDetailObj.pictureUrlList.map(i => $filePathSplicing(i, 'img'))" :initial-index="1" fit="cover"/>
          </div>
        </div>
      </div>
    </div>
    <div class="item-module">
      <div class="title" style="display: flex;flex-direction: row;justify-content: flex-start;align-items: center;">{{ h_i18n('f0d58bfaf3cf5aeb894b315d8f245a0c') }}<el-tooltip effect="dark" placement="top-start" show-arrow="false" :append-to-body="false" popper-class="sub-poper-class">
          <template #content> 
            <div style="font-size: 12px;font-weight: normal;">
              <div>
              <div>{{ h_i18n('0e33ba5127d4b498fc6ca3602490d517') }}</div>
                <div>{{ h_i18n('728f6778e810b981f64647c7849e3672') }}</div>
                <div>{{ h_i18n('b5b20d28c9b825b5045cc9b39880a26d') }}</div>
              </div>
            
              <div>{{ h_i18n('04e99fce60d110f3f9f503080503275c') }}<div>{{ h_i18n('f14fec3548ebe94630abf18422018806') }}</div>
              </div>
            </div>
          </template>
          <div class="tips-content" style="margin-left: 5px;">
            <img src="@/assets/img/tips.png" style="width: 16px;height: 16px;position: relative;left: 4px;top: 4px;"/>
          </div>
        </el-tooltip>
      </div>
      <div class="module-content">
        <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;">
          <el-checkbox v-model="badtype1" value="1" @change="handleBadType1" :disabled="$route.query.isDetail">{{ h_i18n('f67f7d07d1512c4d64a97714706e1f9e') }}</el-checkbox>
          <div @click="handleOpen1" style="cursor: pointer;color: #165dff;">{{isOpen1?h_i18n('def9e98b60e3bfc493bcd7693e702096'):h_i18n('e2edde5adbdf33f6dce59a299cbf5fad')}}</div>
        </div>
        <div v-show="isOpen1">
          <div class="module-status">
            <div class="module-label" style="padding-right: 3px;width: 99px;">{{ h_i18n('6f2709c6291cf6480bc973b2fbab5ee6') }}</div>
            <el-select v-model="detailObj.faultname" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" clearable style="width: 280px !important;margin-left: 10px;" :disabled="$route.query.isDetail">
              <el-option v-for="(item,index) in faultlist" :key="index" :label="item" :value="item" />
            </el-select>
            <div class="primary-btn" @click="addFaultName" v-show="!$route.query.isDetail">{{ h_i18n('66ab5e9f24c8f46012a25c89919fb191') }}</div>
          </div>
          <div class="module-status">
            <div class="module-label">{{ h_i18n('7706b37df0506a197fdcc0eaa8991785') }}</div>
            <el-input v-model="detailObj.badperformance" :placeholder="h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7')" clearable :disabled="$route.query.isDetail" maxlength="200"/>
          </div>
          <div class="module-status">
            <div class="module-label">{{ h_i18n('f3e04893902761f7fa7ff4b386442223') }}</div>
            <el-input type="textarea" v-model="detailObj.firstcaution" :placeholder="h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7')" clearable :disabled="$route.query.isDetail" maxlength="200"/>
          </div>
          <div class="module-status">
            <div class="module-label" style="margin-left: -9px">{{ h_i18n('e2befc425cda043455ae50cb35c79de1') }}</div>
            <el-radio-group v-model="detailObj.changestatus" @change="handleRadio" :disabled="$route.query.isDetail">
              <el-radio label="2">{{ h_i18n('9f83b2d486849bed5055413b4bb0f3e9') }}</el-radio>
              <el-radio label="1">{{ h_i18n('670b52e30cc3679585c3a454d1687e5b') }}</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="module-content">
        <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;">
          <el-checkbox v-model="badtype2" value="2" @change="handleBadType2" :disabled="$route.query.isDetail">{{ h_i18n('0d80dc8935a9ed4221a6c2b06d1b460e') }}</el-checkbox>
          <div @click="handleOpen2" style="cursor: pointer;color: #165dff;">{{isOpen2?h_i18n('def9e98b60e3bfc493bcd7693e702096'):h_i18n('e2edde5adbdf33f6dce59a299cbf5fad')}}</div>
        </div>
        <div v-show="isOpen2">
          <div class="module-status">
            <div class="module-label" style="padding-right: 3px;width: 65px;text-align: left;">{{ h_i18n('bab38b68c5fd1c85cdffe73a6e07c47b') }}</div>
            <el-select v-model="detailObj.notModelBadType" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" style="width: 280px !important;margin-left: 10px;" @change="handleNotModeBadType" :disabled="$route.query.isDetail">
              <el-option v-for="(item,index) in notModelBadTypeList" :key="index" :label="item.label" :value="item.value" />
            </el-select>
          </div>
          <div v-show="detailObj.notModelBadType=='A'||detailObj.notModelBadType=='B'||detailObj.notModelBadType=='C'||detailObj.notModelBadType=='D'||detailObj.notModelBadType=='E'" style="background:#F7F8FA;border-radius: 8px;box-sizing: border-box;padding: 16px;margin-top: 16px; ">
            <div class="checkbox-style">
              <el-checkbox v-show="detailObj.notModelBadType=='A'" v-model="notmodelbadChecked1" value="A1" :label="h_i18n('326287ec677b90bd44c82931ca0158fa')" @change="handleBad" :disabled="$route.query.isDetail"></el-checkbox>
              <el-checkbox v-show="detailObj.notModelBadType=='A'" v-model="notmodelbadChecked2" value="A2" :label="h_i18n('2180d1af0fb304a5d4d3544f8621adb3')" @change="handleModeBad" :disabled="$route.query.isDetail"></el-checkbox>
              <el-checkbox v-show="detailObj.notModelBadType=='B'" v-model="notmodelbadChecked1" value="B1" :label="h_i18n('b95e1c7f8cd52498d1cb51c244ccdb59')" @change="handleBad" :disabled="$route.query.isDetail"></el-checkbox>
              <el-checkbox v-show="detailObj.notModelBadType=='B'" v-model="notmodelbadChecked2" value="B2" :label="h_i18n('3bdd5eb12d5ddf0f1be75569d3399872')" @change="handleModeBad" :disabled="$route.query.isDetail"></el-checkbox>
              <el-checkbox v-show="detailObj.notModelBadType=='C'" v-model="notmodelbadChecked1" value="C1" :label="h_i18n('fd5720d49f6e3f463d9a90f72c860af9')" @change="handleBad" :disabled="$route.query.isDetail"></el-checkbox>
              <el-checkbox v-show="detailObj.notModelBadType=='C'" v-model="notmodelbadChecked2" value="C2" :label="h_i18n('2180d1af0fb304a5d4d3544f8621adb3')" @change="handleModeBad" :disabled="$route.query.isDetail"></el-checkbox>
              <el-checkbox v-show="detailObj.notModelBadType=='D'" v-model="notmodelbadChecked1" value="D1" :label="h_i18n('e6486d819ebc3251f7c14ea7c8268cb1')" @change="handleBad" :disabled="$route.query.isDetail"></el-checkbox>
              <el-checkbox v-show="detailObj.notModelBadType=='E'" v-model="notmodelbadChecked1" value="E1" :label="h_i18n('15e819888e6c20b87fec24eeb48fee54')" @change="handleBad" :disabled="$route.query.isDetail"></el-checkbox>
            </div>
            <div style="display: flex;flex-direction: row;justify-content: flex-start;align-items: center;margin-top: 16px;">
              <div class="module-label" style="text-align: left;width: 62px;">{{ h_i18n('df6645aa395505251665eabefcb84aa8') }}</div>
              <el-input type="textarea" v-model="detailObj.otherreason" :placeholder="h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7')" clearable :disabled="$route.query.isDetail" maxlength="200"/>
            </div>
          </div>
        </div>
      </div>
      <div class="info-item1">
        <div class="info-label">{{ h_i18n('4bd2dde739894e53ce6d7941febe17a1') }}</div>
        <div class="info-content1">
          <hc-file-upload v-if="!$route.query.isDetail"
            :info="h_i18n('0a94aa92aebd0d07cd2fffcb3c3b545f')"
            v-model="fileObj"
            delete
            download
            @change="upLoadImg"
            @delete="deleteFile"
            @error="error"
            @download="handleDownLoad(detailObj.fileUUID,detailObj.fileName)"></hc-file-upload>
          <div style="color: #165dff;cursor: pointer;" v-else>
            <span @click="handleDownLoad(detailObj.fileUUID,detailObj.filename)">{{ detailObj.filename }}</span>
          </div>
        </div>
      </div>
      <div class="info-item1">
        <div class="info-label">{{ h_i18n('a563ec4069f6411dafe2af7711e6d5e4') }}</div>
        <div class="info-content1">
          <!-- <h-date-picker type="date" v-model="detailObj.comptime"  clear-icon="el-icon-error" prefix-icon="iconfont icon-rili2" clearable/> -->
          <el-date-picker v-model="detailObj.comptime" type="date" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" prefix-icon="iconfont icon-rili" :disabled="$route.query.isDetail"/>
        </div>
      </div>
    </div>

    <el-dialog ref="addReasonNameRef" :title="h_i18n('6f2709c6291cf6480bc973b2fbab5ee6')" v-model="showDialog" width="560px" @close="handleCancel" footer>
      <div class="add-item">
        <div class="add-label">{{ h_i18n('b58c7549c0246c55b9cac96383200338') }}</div>
        <el-input v-model.trim="defectName" type="textarea" show-word-limit maxlength="50" :autosize="{ minRows: 2, maxRows: 4 }" style="margin-top: 8px"/>
      </div>
      <template #footer>
        <h-button-group align="right">
          <h-button style="height: 30px;border-radius: 6px;" type="default" @click="closeDefect">{{ h_i18n('625fb26b4b3340f7872b411f401e754c') }}</h-button>
          <h-button style="height: 30px;border-radius: 6px;" type="primary" @click="submitDefect">{{ h_i18n('38cf16f2204ffab8a6e0187070558721') }}</h-button>
        </h-button-group>
      </template>
    </el-dialog>
  </h-list-page>
</template>
<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import moment from 'moment';
export default{
  data(){
    return{
      badtype1:false,
      badtype2:false,
      fileList:[],
      detailObj:{
        badtype:1
      },
      defectName:'',
      showDialog: false,
      topDetailObj:{},
      faultlist:[],
      notModelBadTypeList:[{
        label:h_i18n('cb08af880c276d42e7773bcd88331d25'),
        value:''
      },{
        label:h_i18n('b69a854092c80cf2d56bccc679afc909'),
        value:'A'
      },{
        label:h_i18n('e33ee2d5e02c17f27922dbdbd38e60e9'),
        value:'B'
      },{
        label:h_i18n('ae9fed9fcf1d522dccec91224e68ae55'),
        value:'C'
      },{
        label:h_i18n('135d24ab28a52bd1f98babe43a6e4922'),
        value:'D'
      },{
        label:h_i18n('d81e1c46f02e3aefb91d0ae3d384f59a'),
        value:'E'
      },],
      fileObj:{},
      visible: false,
      notModelBadTypeArray:[{
        label:h_i18n('326287ec677b90bd44c82931ca0158fa'),
        value:'A1'
      },{
        label:h_i18n('2180d1af0fb304a5d4d3544f8621adb3'),
        value:'A2'
      },{
        label:h_i18n('b95e1c7f8cd52498d1cb51c244ccdb59'),
        value:'B1'
      },{
        label:h_i18n('3bdd5eb12d5ddf0f1be75569d3399872'),
        value:'B2'
      },{
        label:h_i18n('fd5720d49f6e3f463d9a90f72c860af9'),
        value:'C1'
      },{
        label:h_i18n('2180d1af0fb304a5d4d3544f8621adb3'),
        value:'C2'
      },{
        label:h_i18n('e6486d819ebc3251f7c14ea7c8268cb1'),
        value:'D1'
      },{
        label:h_i18n('15e819888e6c20b87fec24eeb48fee54'),
        value:'E1'
      }],
      isOpen1: true,
      isOpen2: true,
      notmodelbadChecked1: false,
      notmodelbadChecked2: false,
    }
  },
  methods:{
    h_i18n,
    getMarJhInfo(){
      this.startLoading(h_i18n('26b5bd4947df8be257c59dde927b400c'))
      this.$http({
        method: "post",
        url: `/base/userevaluation/getMarJhinfo?vcode=${this.$route.query.vcode}&gdcode=${this.$route.query.gdcode}`,
      }).then((res) => {
       this.$nextTick(()=>{
          console.log('resresresresresgetMainMidData',res)
          if(res.data.code==0){
            this.detailObj = res.data.data.mj ? res.data.data.mj : {}
            this.detailObj.updateStatus = this.detailObj.updateStatus ? this.detailObj.updateStatus : null
            this.faultlist = res.data.data.faultlist
            
            if(this.detailObj.badtype == '1'){
              this.badtype1 = true
            }else{
              this.badtype1 = false
            }
            if(this.detailObj.badtype == '2'){
              this.badtype2 = true
            }else{
              this.badtype2 = false
            }
            
            if(this.detailObj.notmodelbad == 'A1'||this.detailObj.notmodelbad =='B1'||this.detailObj.notmodelbad =='C1'||this.detailObj.notmodelbad =='D1'||this.detailObj.notmodelbad == 'E1'){
              this.notmodelbadChecked1 = true
            }else{
              this.notmodelbadChecked1 = false
            }
            if(this.detailObj.notModelBad2 == 'A2'||this.detailObj.notModelBad2 =='B2'||this.detailObj.notModelBad2 =='C2'){
                this.notmodelbadChecked2 = true
            }else{
              this.notmodelbadChecked2 = false
            }
            this.fileObj.fileUUID = this.detailObj.fileUUID
            this.fileObj.fileName = this.detailObj.filename
            this.fileObj.name = this.detailObj.filename
          }
          this.closeLoading()
        })
      }).catch(err=>{
        this.closeLoading()
        this.info(err.data.msg)
      })
    },
    getMarInfoJhInfo(){
      this.startLoading(h_i18n('26b5bd4947df8be257c59dde927b400c'))
      this.$http({
        method: "post",
        url: `/base/userevaluation/getMarInfoJh?vcode=${this.$route.query.vcode}&gdcode=${this.$route.query.gdcode}`,
      }).then((res) => {
       this.$nextTick(()=>{
          console.log('getMarInfoJhgetMarInfoJh',res)
          if(res.data.code==0){
            this.topDetailObj = res.data.data
            this.topDetailObj.reportAt = this.topDetailObj.reportAt ? moment(this.topDetailObj.reportAt).format('YYYY-MM-DD') : '--'
            this.topDetailObj.assembledAt = this.topDetailObj.assembledAt ? moment(this.topDetailObj.assembledAt).format('YYYY-MM-DD') : '--'
          }
          this.closeLoading()
        })
      }).catch(err=>{
        this.closeLoading()
        this.info(err.data.msg)
      })
    },
    upLoadImg(options, promise) {
      this.startLoading(h_i18n('92cd554eff7896f979917f3ae449b460'))
      let formData = new FormData();
      formData.append("files", options.file);
      this.$http({
        method: "post",
        url: "/base/fileUpload/uploadToOss",
        headers: { "Content-Type": "multipart/form-data" },
        data: formData,
        cache: false,
        processData: false,
        contentType: false,
      }).then((res) => {
        console.log('res===========',res)
        this.detailObj.fileUUID = res.data.data;
        this.detailObj.fileName = options.file.name;
        console.log('this.detailObj',this.detailObj)
        this.closeLoading()
      }).catch((err) => {
        this.closeLoading()
        this.error(err.data.msg||h_i18n('8e2f993840e3108c7f6d8f23d6a8a08d'));
      });
    },
    deleteFile() {
      this.detailObj.fileUUID = "";
      this.detailObj.fileName = "";
      this.detailObj.filename = "";
      this.fileObj = undefined
    },
    error(str){
      this.warning({ title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: str, confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721') });
    },
    handleDownLoad(uuid,fileName){
      if(uuid == ""||uuid == undefined ||uuid == null){
        this.info(h_i18n('e334e916fdda30d81fe74a8cdeb97d65'));
        return false;
      }
      let suffix = uuid.includes("mkhl/");
      console.log('suffix',suffix)
      if (suffix) {
        let url = "/base/fileDownload/downloadFile?filePath=" + uuid;
        this.httpFile(
          {
            method: "get",
            url: url,
            headers: { "content-type": "application/json" },
          },
          fileName
        );
      } else {
        let url = `/base/fileDownload/downLoadFileFtp?type=8&fileUUID=${uuid}`;
        this.httpFile(
          {
            method: "get",
            url: url,
            headers: { "content-type": "application/json" },
          },
          fileName
        );
      }
    },
    addFaultName(){
      this.defectName = ''
      this.showDialog = true
    },
    submitDefect(){
      if(this.defectName==''||this.defectName==null||this.defectName==undefined){
        this.info(h_i18n('51bc73884a48faf43d6c8afb5d4b2932'))
        return false
      }
      this.faultlist.push(this.defectName)
      this.showDialog = false
    },
    closeDefect(){
      this.defectName = ''
      this.showDialog = false
    },
    handleBack(){
      let obj = this.$route.query
      delete obj.gdcode
      this.$router.push({name:'userParallelConnection',query:obj})
    },
    handleSubmit(){
    //           return false;
    //       }
    //       if(badper.length==0){alert("请填写不良现象!");return false;}
    //       if(fcau.length==0){alert("请填写不良原因!");return false;}
    //       if(cgsta==null){alert("请选择改进状态!");return false;}
    //   }else if($("#nomd").attr("checked")=='checked'){
    //       badtype="2";
    //       if(notModelBadType == null || notModelBadType == ''){
    //           alert("请选择非模块不良类型!");
    //           return false;
    //       }
    //       if(nobad == null && notModelBad2 == null){
    //           alert("请选择非模块不良类型的子类型!");
    //           return false;
    //       }
    //   }else{alert("请选择是否为模块不良！");return false;}
    //   $.ajax({
    //     type : "GET",
    //     dataType : "json",
    //     url : "../api/MarJhinfo",
    //     data:{
    //         "gdcode": gdcode,
    //         "vcode":vcode,
    //         "badtype":badtype,
    //         "badper":badper,
    //         "faultname":faultname,
    //         "fcau":fcau,
    //         "cgsta":cgsta,
    //         "nobad":nobad,
    //         "otherreason":otherreason,
    //         "notModelBadType":notModelBadType,
    //         "notModelBadTypeName":notModelBadTypeName,
    //         "notModelBad2":notModelBad2
    //     },
    //     success : function(data){
    //         alert("信息提交成功！点击确定关闭当前页面！");
            
    //     },
    //     error:function(){
    //         alert("网页发生异常!");
    //     }
    //   });
      this.detailObj.badtype = 1
      let notModelBad2 = ''
      let notModelBad1 = ''
      if(this.badtype1){
        this.detailObj.badtype = 1
        if(this.detailObj.faultname == ''|| this.detailObj.faultname == null || this.detailObj.faultname == undefined){
          this.info(h_i18n('86040805bed1da531854eb6411db0852'))
          return
        }
        if(this.detailObj.badperformance == ''|| this.detailObj.badperformance == null|| this.detailObj.badperformance == undefined){
          this.info(h_i18n('4aa5493ffd3780da536470d8b676a147'));
          return false;
        }
        if(this.detailObj.firstcaution == ''|| this.detailObj.firstcaution == null||this.detailObj.firstcaution == undefined){
          this.info(h_i18n('32d4976a8b9b7b8aebb2904a2ec1c94b'));
          return false;
        }
        if(this.detailObj.changestatus==''||this.detailObj.changestatus==null||this.detailObj.changestatus==undefined){
          this.info(h_i18n('b57dac19b94415af9d3bee1aaf1cad09'));
          return false;
        }
      }else if(this.badtype2){
        this.detailObj.badtype = 2
        if(this.detailObj.notModelBadType == null || this.detailObj.notModelBadType == '' || this.detailObj.notModelBadType==undefined){
          this.info(h_i18n('518d1a796189fa552f2162ec712302be'));
          return false;
        }
        console.log('this.detailObj.nobad',this.detailObj.nobad)
        console.log('this.detailObj.notModelBad2',this.detailObj.notModelBad2)
        // notmodelbadChecked1
        if((this.notmodelbadChecked1 == null||this.notmodelbadChecked1 == undefined||this.notmodelbadChecked1 == '') && (this.notmodelbadChecked2 == null||this.notmodelbadChecked2 == ''||this.notmodelbadChecked2 == undefined)){
          this.info(h_i18n('c380d3ddac3650cdccdf7019d457682f'));
          return false;
        }
        if(this.notmodelbadChecked2&&this.detailObj.notModelBadType=='A'){
          notModelBad2 = 'A2'
        }
        if(this.notmodelbadChecked2&&this.detailObj.notModelBadType=='B'){
          notModelBad2 = 'B2'
        }
        if(this.notmodelbadChecked2&&this.detailObj.notModelBadType=='C'){
          notModelBad2 = 'C2'
        }
        if(this.notmodelbadChecked1&&this.detailObj.notModelBadType=='A'){
          notModelBad1 = 'A1'
        }
        if(this.notmodelbadChecked1&&this.detailObj.notModelBadType=='B'){
          notModelBad1 = 'B1'
        }
        if(this.notmodelbadChecked1&&this.detailObj.notModelBadType=='C'){
          notModelBad1 = 'C1'
        }
        if(this.detailObj.notModelBadType=='D'){
          notModelBad1 = 'D1'
        }
        if(this.detailObj.notModelBadType=='E'){
          notModelBad1 = 'E1'
        }
      }else{
        this.info(h_i18n('d043d51739196e511703cb499594804d'));
        return false;
      }
      
      console.log(' this.detailObj.notModelBadTypeName.', this.detailObj)
      this.$http({
        method: "post",
        url: `/base/userevaluation/MarJhSubmit`,
        data:{
          badperformance: this.detailObj.badperformance,
          badtype: this.detailObj.badtype,
          booktime: this.detailObj.booktime,
          changestatus: this.detailObj.changestatus,
          comptime: this.detailObj.comptime,
          faultname: this.detailObj.faultname,
          fileUUID: this.detailObj.fileUUID,
          filename: this.detailObj.fileName||this.detailObj.filename,
          firstcaution: this.detailObj.firstcaution,
          gdcode: this.$route.query.gdcode,
          notModelBad2: notModelBad2,
          notModelBadType: this.detailObj.notModelBadType,
          notModelBadTypeName: this.detailObj.notModelBadTypeName,
          otherreason: this.detailObj.otherreason,
          updateStatus: this.detailObj.updateStatus,
          vcode: this.$route.query.vcode,
          notmodelbad: notModelBad1
        }
      }).then((res) => {
        this.closeLoading()
        console.log('rerererere',res)
          this.$nextTick(()=>{
            console.log('resresresresresgetMainMidData',res)
            if(res.data.code==0){
              this.$message({
                message: h_i18n('7bceadff9f30371831a982370149c138'),
                type: 'success'
              });
              this.handleBack()
            }else{
              this.error(res.data.msg)
            }
          })
      }).catch(err=>{
        this.closeLoading()
        this.info(err.data.msg)
      })
    },
    handleRadio(val){
      console.log('vallllll',val)
      this.detailObj.changestatus = val
    },
    // handleBad(val){
    //   this.detailObj.nobad = val
    // },
    // handleModeBad(val){
    //   this.detailObj.notModelBad2 = val
    // },
    handleNotModeBadType(val){
      this.detailObj.notModelBadType = val
      let tmpList = this.notModelBadTypeList.filter(item => item.value == val ? item.label : '' )
      this.detailObj.notModelBadTypeName = tmpList[0].label
      console.log('this.detailObj.notModelBadTypeName',this.detailObj.notModelBadTypeName)
      this.notmodelbadChecked1 = false
      this.notmodelbadChecked2 = false
    },
    handleBadType1(val){
      if(val){
        this.badtype1=val
      }
      console.log('this.badType111',val,this.badtype1)
    },
    handleBadType2(val){
     if(val){
      this.badtype2=val
     }
    console.log('this.badType222',val,this.badtype2)
    },
    handleOpen1(){
      this.isOpen1 = !this.isOpen1
    },
    handleOpen2(){
      this.isOpen2 = !this.isOpen2
    }
  },
  mounted(){
    this.getMarJhInfo()
    this.getMarInfoJhInfo()
  }
}
</script>

<style scoped>
.is-hwork{
  width: 100%;
  min-width: 100%;
  box-sizing: border-box;
}
.is-button-hwork .haier-button--default{
  border-radius: 8px;
}

</style>

<style lang="scss" scoped>
.complaint-container{
  .title-content{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 48px;
    line-height: 48px;
    padding: 0 16px;
    background: #fff;
    .title{
      color: #1D2129;
      font-size: 18px;
    }
  }
  .item-module{
    box-sizing: border-box;
    background: #fff;
    border-radius: 8px;
    min-height: 124px;
    height: auto;
    padding: 16px;
    margin-top: 12px;
    .tips-content{
      width: 24px;
      height: 24px;
      background: #F1F2F8;
      border-radius: 6px;
    }
    .title{
      color: #1D2129;
      font-size: 14px;
      font-weight: bold;
    }
    .info-content{
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      // margin-top: 16px;
    }
    .info-item{
      width: 25%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-top: 16px;
      font-size: 14px;
      .info-label{
        color: #4E5969;
      }
      .info-content{
        color: #1D2129;
        width: 75%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
    .info-item1{
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      margin-top: 16px;
      font-size: 14px;
      .info-label{
        width: 75px;
        color: #4E5969;
      }
      .info-content1{
        width: calc(100% - 75px);
        color: #1D2129;
        // width: 75%;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // display: -webkit-box;
        // -webkit-line-clamp: 1;
        // -webkit-box-orient: vertical;
      }
    }
    .info-img{
      box-sizing: border-box;
      width: 80px;
      height: 80px;
      border-radius: 8px;
      padding: 4px;
      border: 1px solid #C9CDD4;
      margin-right: 8px;
    }
  }
  .module-content{
    border: 1px solid #e5e6eb;
    border-radius: 8px;
    padding: 16px;
    margin-top: 12px;
    .module-status{
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-top: 16px;
    }
    .module-label{
      color: #4E5969;
      width: 110px;
      text-align: right;
      padding-right: 12px;
    }
  }
}
.primary-btn{
  display: inline-block;
  min-width: 60px;
  max-width: 80px;
  height: 30px !important;
  line-height: 30px !important;
  text-align: center;
  background: #165DFF;
  border: 1px	solid#165DFF;
  color: #fff;
  border-radius: 6px;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 8px;
  &:hover{
    background: rgba(22, 93, 255, 0.1);
  }
  &:active{
    color: #0E42D2;
    background: rgba(14, 66, 210, 0.1);
    border: 1px	solid rgb(14, 66, 210);
  }
}
.reset-btn{
  display: inline-block;
  width: 60px;
  height: 30px !important;
  line-height: 30px !important;
  text-align: center;
  background: #fff;
  border: 1px	solid#C9CDD4;
  color: #1D2129;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  margin-left: 12px;
  &:hover{
    background: rgba(22, 93, 255, 0.1);
  }
  &:active{
    color: #0E42D2;
    background: rgba(14, 66, 210, 0.1);
    border: 1px	solid rgb(14, 66, 210);
  }
}
.checkbox-style :deep(.el-checkbox){
  color: #1D2129;
}
.add-item{
  margin-top: -13px;
  .add-label{
    color: #4E5969;
  }
}

.sub-poper-class .popper__arrow {
  display: none; /* 首先隐藏默认箭头 */
  /* 添加你自己的自定义箭头样式，例如： */
  .my-custom-arrow {
    /* 定义你的自定义箭头样式 */
    background: url('../../../assets/img/arrow1.png');
  }
}

// .sub-poper-class.el-tooltip__popper {
//   background: rgba(2, 9, 25, 0.7) !important;
//   border: none
// }

// .sub-poper-class.el-tooltip__popper .popper__arrow {
//   border: none;
//   background: rrgba(2, 9, 25, 0.7) !important;
//   /* box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15); */
// }

</style>